import {
    Grid,
    Typography
} from '@mui/material';

const PrivacyPolicyForm = () => {
    return (
        <Grid container>
            <Grid item md={12} sm={12} xs={12}>
                <Typography component={'div'} className='set-parent-settings d-flex-ja'>
                    <Typography component={'div'} className='set-child'>
                        <Typography className='p-title sett-box d-flex-a px-24'>Privacy Policy</Typography>
                        <Typography component={'div'} className='company-text'>
                            People Optimizaton Index
                        </Typography>
                        <Typography component={'div'} className='px-24'>
1. Overview<br/>
People Optimization Index (“POI,” “we,” “our,” or “us”) respects your privacy and is committed to protecting personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard information when you use the POI web application, including survey and analytics features.<br/>
<br/>
2. Information We Collect<br/>
2.1 Personal Information<br/>
We may collect the following:<br/>
Name, email address, and job-related information<br/>
Company affiliation and role<br/>
Contact information (including phone number if provided)<br/>
<br/>
2.2 Survey and Assessment Data<br/>
Survey responses<br/>
Engagement and performance metrics<br/>
Feedback provided by users<br/>
<br/>
2.3 Technical and Usage Data<br/>
IP address<br/>
Browser type and device information<br/>
Login activity and usage patterns<br/>
Cookies and tracking data<br/>
<br/>
2.4 SMS / Messaging Data<br/>
If enabled:<br/>
Mobile phone number<br/>
Messaging preferences (opt‑in/opt‑out status)<br/>
SMS interaction history<br/>
<br/>
3. How We Use Information<br/>
We use collected information to:<br/>
Deliver and improve the POI platform<br/>
Provide survey insights and people analytics<br/>
Generate reports and dashboards<br/>
Communicate system updates and notifications<br/>
Support customer service and troubleshooting<br/>
Ensure platform security and compliance<br/>
<br/>
We may aggregate and anonymize data to:<br/>
Improve benchmarking and analytics<br/>
Enhance product performance and features<br/>
<br/>
4. SMS Communications<br/>
If you opt into SMS messages:<br/>
<br/>
You may receive notifications related to surveys, reminders, or system updates<br/>
You may opt out at any time by replying “STOP”<br/>
Opt-out requests are processed within a reasonable timeframe<br/>
<br/>
Message and data rates may apply depending on your carrier.<br/>
<br/>
5. How We Share Information<br/>
We do not sell personal data. We may share information with:<br/>
<br/>
5.1 Service Providers<br/>
Cloud hosting providers (e.g., Azure)<br/>
Analytics and messaging providers (e.g., email/SMS platforms)<br/>
<br/>
5.2 Business Customers<br/>
If you access POI through your employer:<br/>
<br/>
Your organization may receive reports, analytics, or aggregated data<br/>
Individual-level data may be shared depending on configuration and agreements<br/>
<br/>
5.3 Legal and Compliance<br/>
We may disclose information:<br/>
<br/>
To comply with legal obligations<br/>
To enforce our terms and protect rights<br/>
To prevent fraud or security threats<br/>
<br/>
6. Data Security<br/>
We implement reasonable administrative, technical, and physical safeguards to protect your data, including:<br/>
<br/>
Access controls and authentication<br/>
Encryption in transit (TLS)<br/>
Secure cloud infrastructure<br/>
<br/>
However, no system is 100% secure, and we cannot guarantee absolute security.<br/>
<br/>
7. Data Retention<br/>
We retain personal data:<br/>
<br/>
As long as necessary to provide services<br/>
As required by contractual or legal obligations<br/>
Based on customer configuration and retention policies<br/>
<br/>
Data may be deleted or anonymized upon request, subject to limitations.<br/>
<br/>
8. Your Rights and Choices<br/>
Depending on your location, you may have the right to:<br/>
<br/>
Access your personal information<br/>
Correct inaccurate data<br/>
Request deletion<br/>
Restrict or object to processing<br/>
<br/>
To exercise these rights, contact us at the email below.<br/>
<br/>
9. Cookies and Tracking Technologies<br/>
We use cookies and similar technologies to:<br/>
<br/>
Authenticate users<br/>
Improve website experience<br/>
Analyze usage trends<br/>
<br/>
You may disable cookies in your browser settings, though this may impact functionality.<br/>
<br/>
10. Third-Party Services<br/>
The POI platform may integrate with third-party tools (e.g., payroll systems, HR platforms, analytics providers).<br/>
These providers have their own privacy practices, and we encourage you to review their policies.<br/>
<br/>
11. Children’s Privacy<br/>
POI is not intended for individuals under age 16.<br/>
We do not knowingly collect data from minors.<br/>
<br/>
12. International Data Transfers<br/>
Data may be processed or stored in the United States or other jurisdictions where our service providers operate, subject to appropriate safeguards.<br/>
<br/>
13. Changes to This Policy<br/>
We may update this Privacy Policy periodically.<br/>
Changes will be posted with an updated effective date.<br/>
<br/>
14. Contact Information<br/>
For questions, requests, or concerns:<br/>
People Optimization Index<br/>
Email: infosecurity@theencompassgroup.com<br/>
Address: 405 State Highway 121 Bypass<br/>
Suite D120<br/>
Lewisville, TX 75067.
                        </Typography>
                        <Typography component={'div'} className='px-24'>                            
                        </Typography>
                        <Typography component={'div'} className='box-bottom'>
                            &copy; The Encompasss Group (2026)
                        </Typography>
                    </Typography>
                </Typography>
            </Grid>
        </Grid>
    )
}

export default PrivacyPolicyForm;